export const ADVISOR_IMAGE = '.advisor-round-image';
export const ADVISOR_NAME = '.advisor-heading-align-bottom h1';
